export const CUSTOMER_DETAILS_HEADER = 'Customer';
